
import { mapState } from 'vuex';
import linkBusinessMixin from '~/mixins/linkBusiness';
import registerUserMixin from '~/mixins/registerUser';
import promiseErrors from '~/services/promiseErrors';

export default {
    name: 'Register',
    mixins: [registerUserMixin, linkBusinessMixin],
    async asyncData({ app, route }) {
        if (!route.query.org_token) {
            return {};
        }

        const [organisation] = await promiseErrors([app.$axios.$get(`organisation/token/${route.query.org_token}`)], app);

        return {
            token: organisation?.data,
        };
    },
    data() {
        return {
            wastewarrior: this.$route.query.wastewarrior || false,
            token: null,
        };
    },
    computed: mapState(['auth']),
    async mounted() {
        this.$store.dispatch('hideNav');

        if (this.auth.loggedIn) {
            if (!this.linkBusiness()) {
                return;
            }
            this.$router.replace({ name: 'dashboard' });
        }
    },
    created() {
        this.addUserValidations();
    },
    methods: {
        submit() {
            this.registerUser().then(() => {
                this.$router.push({ name: 'dashboard', query: { ...(this.wastewarrior && { wastewarrior: this.wastewarrior }) } });
            });
        },
    },
    validations: {},
};
